export enum CalendarType {
    other = 0,
    user = 1,
    resource = 2,
    project = 3,
    role = 4
}
export namespace CalendarType{
    export function getName(value: CalendarType): string {
        switch (value) {
            case CalendarType.other:
                return "other";
            case CalendarType.user:
                return "user";
            case CalendarType.resource:
                return "resource";
            case CalendarType.project:
                return "project";
            case CalendarType.role:
                return "role";
            default:
                return "???";
        }
    }
}
